module.exports = __webpack_public_path__ + "static/media/guide_img1_4.baeced3a.png";